import styled from 'styled-components';

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.red};
  padding: 3px;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
  bottom: -20px;
  left: 15px;
`;
